import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type InlineReferenceValidationType = 'type' | 'name' | null

type InlineReferenceValidationToggleState = {
  inlineReferenceValidationType: InlineReferenceValidationType
  setInlineReferenceValidationType: (type: InlineReferenceValidationType) => void
}

export const useInlineReferenceValidationToggleStore = create<InlineReferenceValidationToggleState>()(
  persist(
    set => ({
      inlineReferenceValidationType: null,
      setInlineReferenceValidationType: (type: InlineReferenceValidationType) =>
        set({ inlineReferenceValidationType: type }),
    }),
    {
      name: 'corelia:source-validation-state',
    },
  ),
)
